<div class="clinic-exam" [formGroup]="form">

    <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">

        <ng-container *ngFor="let f of fields">

            <!-- =============== section header =============== -->
            <div class="w100 clinic-exam-header" *ngIf="f.FieldType === 'header'">
                <h2>{{ f.Label }}</h2>
                <div class="sep-8"></div>
            </div>

            <!-- =============== free text + Auto Text =============== -->
            <div [ngClass]="f.Width" *ngIf="f.FieldType === 'text'">
                <section class="m-box fulltext">
                    <h2>
                        {{ f.Label }}
                        <span class="retired-note" *ngIf="f.Retired">הוסר מהתבנית</span>
                    </h2>
                    <textarea [formControlName]="name(f)" class="scroller scroller-intro fulltext"
                        [style.min-height]="f.Config.minHeight || '10em'" dir="auto"></textarea>
                    <button class="t-btn-edit" type="button" *ngIf="!es.isClosed && hasAutoText(f)"
                        (click)="showAutoText(f)">Auto Text</button>
                </section>
            </div>

            <!-- =============== yes / no + conditional comment =============== -->
            <div [ngClass]="f.Width" *ngIf="f.FieldType === 'yesno'">
                <section class="m-box">
                    <h2>
                        {{ f.Label }}
                        <span class="retired-note" *ngIf="f.Retired">הוסר מהתבנית</span>
                    </h2>
                    <div class="anatomy-twin-radios" style="margin-block-start: 0.3em;"
                        (dblclick)="reset(f, '', true)">
                        <label class="observe">
                            <input type="radio" class="custom-check customInput" [name]="name(f)"
                                [formControlName]="name(f)" [value]="f.Config.leftValue" />
                            <i class="customInput-display"></i>
                            <span>{{ f.Config.left || 'Normal' }}</span>
                        </label>
                        <label class="not-observe">
                            <input type="radio" class="custom-check customInput" [name]="name(f)"
                                [formControlName]="name(f)" [value]="f.Config.rightValue" />
                            <i class="customInput-display"></i>
                            <span>{{ f.Config.right || 'Abnormal' }}</span>
                        </label>
                    </div>
                    <!-- shown whenever the admin enabled it, not only for one side -->
                    <div class="commDiv" *ngIf="f.Config.comment">
                        <label>Comments</label>
                        <textarea class="fulltext" [formControlName]="name(f, 'c')" dir="auto"
                            style="height: 100%; margin-block-start: 1em; border: revert;"></textarea>
                        <button class="t-btn-edit" type="button" *ngIf="!es.isClosed && hasAutoText(f)"
                            (click)="showAutoText(f, 'c')">Auto Text</button>
                    </div>
                </section>
            </div>

            <!-- =============== number + unit =============== -->
            <div [ngClass]="f.Width" *ngIf="f.FieldType === 'number'">
                <section class="m-box">
                    <h2>
                        {{ f.Label }}
                        <span class="retired-note" *ngIf="f.Retired">הוסר מהתבנית</span>
                    </h2>
                    <div style="margin: 1em; padding: 0.5em; text-align: -webkit-center;"
                        (dblclick)="reset(f)">
                        <span class="t-field t-field--number">
                            <input class="t-field-text" [formControlName]="name(f)" [name]="name(f)" />
                            <span class="t-field-desc" *ngIf="f.Config.unit">{{ f.Config.unit }}</span>
                        </span>
                    </div>
                </section>
            </div>

            <!-- =============== select =============== -->
            <div [ngClass]="f.Width" *ngIf="f.FieldType === 'select'">
                <section class="m-box">
                    <h2>
                        {{ f.Label }}
                        <span class="retired-note" *ngIf="f.Retired">הוסר מהתבנית</span>
                    </h2>
                    <label class="t-label-top" (dblclick)="reset(f)">
                        <select class="t-select t-field" [formControlName]="name(f)"
                            style="margin-block: 0.3em; text-align-last: right; direction: rtl;">
                            <option></option>
                            <option *ngFor="let o of f.Config.options" [value]="o">{{ o }}</option>
                        </select>
                    </label>
                </section>
            </div>

            <!-- =============== picklist: textarea + inline clickable items =============== -->
            <div [ngClass]="f.Width" *ngIf="f.FieldType === 'picklist'">
                <section class="m-box fulltext">
                    <h2>
                        {{ f.Label }}
                        <span class="retired-note" *ngIf="f.Retired">הוסר מהתבנית</span>
                    </h2>
                    <div class="picklist">
                        <textarea class="scroller fulltext" [formControlName]="name(f)" dir="auto"
                            style="min-height: 7em;" (dblclick)="reset(f)"></textarea>
                        <div class="picklist-items scroller">
                            <div class="picklist-item" *ngFor="let a of f.autoTexts" dir="auto"
                                [class.disabled]="es.isClosed" (click)="appendItem(f, a.Content)">
                                {{ a.Content }}
                            </div>
                            <div class="empty" *ngIf="!f.autoTexts.length">לא הוגדרו פריטים</div>
                        </div>
                    </div>
                </section>
            </div>

            <!-- =============== table =============== -->
            <div [ngClass]="f.Width" *ngIf="f.FieldType === 'table'">
                <section class="m-box">
                    <h2>
                        {{ f.Label }}
                        <span class="retired-note" *ngIf="f.Retired">הוסר מהתבנית</span>
                    </h2>
                    <div class="l-table-auto clinic-table">
                        <div class="l-row clinic-table-row" *ngFor="let r of f.Config.rows; let i = index">
                            <div class="l-td-m clinic-table-label" dir="auto">{{ r.label }}</div>
                            <div class="l-td-m">
                                <div class="anatomy-twin-radios" (dblclick)="reset(f, rowKey(i), true)">
                                    <label class="observe">
                                        <input type="radio" class="custom-check customInput"
                                            [name]="name(f, rowKey(i))" [formControlName]="name(f, rowKey(i))"
                                            [value]="f.Config.leftValue === undefined ? 0 : f.Config.leftValue" />
                                        <i class="customInput-display"></i>
                                        <span>{{ f.Config.left || 'Normal' }}</span>
                                    </label>
                                    <label class="not-observe">
                                        <input type="radio" class="custom-check customInput"
                                            [name]="name(f, rowKey(i))" [formControlName]="name(f, rowKey(i))"
                                            [value]="f.Config.rightValue === undefined ? 1 : f.Config.rightValue" />
                                        <i class="customInput-display"></i>
                                        <span>{{ f.Config.right || 'Abnormal' }}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="l-td-m clinic-table-comment" *ngIf="f.Config.comment">
                                <textarea class="fulltext" [formControlName]="name(f, rowKey(i, true))" dir="auto"
                                    style="border: revert;"></textarea>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <!-- =============== summary (rich text) =============== -->
            <div [ngClass]="f.Width" *ngIf="f.FieldType === 'summary'">
                <section class="m-box">
                    <h2>
                        {{ f.Label }}
                        <span class="retired-note" *ngIf="f.Retired">הוסר מהתבנית</span>
                    </h2>
                    <angular-editor [formControlName]="name(f)" [config]="editorConfig"
                        style="width: 100%"></angular-editor>
                    <button class="t-btn-edit" type="button" *ngIf="!es.isClosed && hasAutoText(f)"
                        (click)="showAutoText(f, '', true)">Auto Text</button>
                </section>
            </div>

        </ng-container>

        <div class="w100 empty-exam" *ngIf="loaded && !fields.length">
            לא הוגדרו אינפוטים בתבנית של הבדיקה הזאת.
        </div>
    </div>

    <app-exam-diagnoses></app-exam-diagnoses>
    <app-exam-payer [examId]="es.examID"></app-exam-payer>
    <!-- =============== Exam Signature =============== -->
    <app-gastro-summary [signOnly]="true"></app-gastro-summary>
</div>

<app-clinic-field-autotext *ngIf="autoTextField" [field]="autoTextField" [control]="autoTextControl"
    [isHtml]="autoTextIsHtml" (closed)="closeAutoText()"></app-clinic-field-autotext>
